<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.first_deposit") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-12.col-lg-3.col-xl-3.col-12.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getListing()" size="sm")
              .form-group.col-md-12.col-lg-3.col-xl-3.col-12.mb-1
                DateRangePicker(:value="dateRange" @update="getData").mr-3
              .form-group.col-md-12.col-lg-3.col-xl-3.col-12.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.ftd_amount_min") }}
                  b-form-input(
                    size="sm"
                    type="text"
                    v-model="ftd_min"
                    @keypress="onlyNumber"
                  )
              .form-group.col-md-12.col-lg-3.col-xl-3.col-12.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.ftd_amount_max") }}
                  b-form-input(
                    size="sm"
                    type="text"
                    v-model="ftd_max"
                    @keypress="onlyNumber"
                  )
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getListing()"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="firstDepositList.length > 0" mode="FirstDeposit" :dttbl="firstDepositListFull" :date="dateRange" type="1" :loading2="loading2")

          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12(style="max-height: 70vh; overflow: hidden;")
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList(style="width:110% !important;")
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="7%")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                        th(width="7%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")                        
                        th(width="7%" @click="sortOrder('full_name')")
                          span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                          .float-right
                            i(:class="changeSortKey('full_name')")
                        th(width="8%" @click="sortOrder('contact_phone')")
                          span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
                          .float-right
                            i(:class="changeSortKey('contact_phone')")                        
                        th(width="6%" @click="sortOrder('promotion_id')")
                          span(:title="$t('ui.promo_id')") {{ $t("ui.promo_id") }}
                          .float-right
                            i(:class="changeSortKey('promotion_id')")
                        th(width="7%" @click="sortOrder('promotion_name')")
                          span(:title="$t('ui.promo_name')") {{ $t("ui.promo_name") }}
                          .float-right
                            i(:class="changeSortKey('promotion_name')")
                        th(width="12%" @click="sortOrder('fl_provider_code')")
                          span(:title="$t('ui.fl_provider_code')") {{ $t("ui.fl_provider_code") }}
                          .float-right
                            i(:class="changeSortKey('fl_provider_code')")
                        th(width="14%" @click="sortOrder('fl_game_id')")
                          span(:title="$t('ui.fl_game_id')") {{ $t("ui.fl_game_id") }}
                          .float-right
                            i(:class="changeSortKey('fl_game_id')")
                        th(width="14%" @click="sortOrder('fl_game_name')")
                          span(:title="$t('ui.fl_game_name')") {{ $t("ui.fl_game_name") }}
                          .float-right
                            i(:class="changeSortKey('fl_game_name')")
                        th.text-right(width="5%" @click="sortOrder('ftd_amount')")
                          span(:title="$t('ui.ftd_amount')") {{ $t('ui.ftd_amount') }}
                          .float-right
                            i(:class="changeSortKey('ftd_amount')")
                        th.text-right(width="10%" @click="sortOrder('ftd_date')")
                          span(:title="$t('ui.ftd_date')") {{ $t("ui.ftd_date") }}
                          .float-right
                            i(:class="changeSortKey('ftd_date')")
                    tbody.clusterize-content
                      tr(v-if="firstDepositList.length == 0")
                        td(colspan="12").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in firstDepositList")
                        td.text-center
                          span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.parent_id") {{ item.parent_id }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.full_name") {{ item.full_name }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}                                          
                        td
                          span(:title="item.promotion_id") {{ item.promotion_id }}
                        td
                          span(:title="item.promotion_name") {{ item.promotion_name }}
                        td
                          span(:title="item.fl_provider_code") {{ item.fl_provider_code }}
                        td
                          span(:title="item.fl_game_id") {{ item.fl_game_id }}
                        td
                          span(:title="item.fl_game_name") {{ item.fl_game_name }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.ftd_amount)" :title="$n(item.ftd_amount, 'currency')") {{ $n(item.ftd_amount, 'currency') }}
                        td.text-right
                          span(:title="$moment(item.ftd_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.ftd_date).format('YYYY-MM-DD, HH:mm:ss') }}      

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading2: false,
    loading: false,
    firstDepositListFull: [],
    firstDepositList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "claim_date",
    sortType: "desc",
    ftd_min: null,
    ftd_max: null,
    searchID: '',
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
        this.getFirstDeposit(true);
        this.getFirstDepositFull();
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }

        if(this.searchID.trim() != '') {
          this.getFirstDeposit(true);
          this.getFirstDepositFull();
        }
      }
    }
  },
  methods: {
    getListing() {
      this.getFirstDeposit(true);
      this.getFirstDepositFull();
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 45) { // 46 is dot
          $event.preventDefault();
      }
    },
    isNumeric(str) {
      if (typeof str != "string") return false
      return !isNaN(str) && !isNaN(parseFloat(str))
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getFirstDeposit(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');

      if (!this.isNumeric(this.ftd_min) && this.ftd_min) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.minFTDAmtNumOnly"), "error");
        return;
      }

      if (!this.isNumeric(this.ftd_max) && this.ftd_max) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.maxFTDAmtNumOnly"), "error");
        return;
      }

      this.getFirstDeposit(true);
      this.getFirstDepositFull();
    },
    getFirstDepositFull: function(isSearch) {
      if (this.checkDateRange()) {
        if (this.searchID.trim() == '') {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
          return;
        }
        this.setReportStatementParam();
        let url = config.firstDepositUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          ftd_min: this.ftd_min,
          ftd_max: this.ftd_max,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.firstDepositListFull = response.data.dt;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getFirstDeposit: function(isSearch) {
      if (!this.isNumeric(this.ftd_min) && this.ftd_min) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.minFTDAmtNumOnly"), "error");
        return;
      }

      if (!this.isNumeric(this.ftd_max) && this.ftd_max) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.maxFTDAmtNumOnly"), "error");
        return;
      }

      if (this.checkDateRange()) {
        if (this.searchID.trim() == '') {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
          return;
        }
        let url = config.firstDepositUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          ftd_min: this.ftd_min,
          ftd_max: this.ftd_max,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.firstDepositList = response.data.dt;
                  this.totalRow = this.firstDepositList.length > 0 ? this.firstDepositList[0].totalrows : 0;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getFirstDeposit(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getFirstDeposit();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>